import React, { useContext, useState, useEffect } from 'react'
import { useHistory } from "react-router-dom"
import { useQuery } from '@apollo/client'
import { useParams } from "react-router-dom"
import Icons from '../../Components/Icons'
import Spinner from '../../Components/Spinner/Spinner'
import NotFound from '../NotFound/NotFound'
import { GET_ANNOUNCE } from '../../../graphql/index'
import {CATEGORY_RIAN, CATEGORY_ONLINE, DOMAIN, SEARCH_INITIAL_FILTER, AUTH_NOT_AUTHORIZED} from '../../../constant'
import {FilterContext, CategoryContext, UserContext, EventContext, TourContext} from "../../../context/index"
import { ModalContext } from "../../../context"
import {setSearchParams, getTime, formatDate} from "../../../utils"
import css from './Event.module.scss'
import lCss from '../../Layout/Layout.module.scss'
import {fetchLogout} from "../../../api/api";

export default function Event () {
	const {eventId} = useParams()
	const history = useHistory()
	const {setFilter} = useContext(FilterContext)
	const {categories} = useContext(CategoryContext)
	const {user} = useContext(UserContext)
	const {setEvent} = useContext(EventContext)
	const {openModal} = useContext(ModalContext)
	const { tour, openTour } = React.useContext(TourContext)
	const [copySuccess, setCopySuccess] = useState(false)
	const {data, loading} = useQuery(GET_ANNOUNCE, {
		variables: {article_id: eventId},
	})
	const announce = data?.announce || {}
	const announceCategories = announce.categories || []
	const list_ids = announceCategories.map(e => e.list_id)

	const setCategory = (item) => {
		const newsState = {...SEARCH_INITIAL_FILTER,...{list_ids_arr: [item.list_id]}}
		history.push({pathname:'/search', search: setSearchParams(newsState)})
		setFilter(newsState)
	}

	const copyToClipboard = () => {
		const textField = document.createElement('textarea');
		textField.value = (announce?.article_title + '\n\n' + announce?.article_body).replace(/<\/?[^>]+>/g, '').replace(/&nbsp;/gi, " ");
		document.body.appendChild(textField);
		textField.select();
		document.execCommand('copy');
		textField.remove();
		setCopySuccess(true);
		setTimeout(() => {
			setCopySuccess(false);
		}, 1000);
	}

	const openSendAnnounces = () =>{
		openModal('sendAnnounces')
	}

	useEffect(() => {
		setEvent({article_id: eventId})
		window.scrollTo(0,0)
	},[])

	useEffect(() => {
		// if(!loading && tour.tour){
			// openTour({
			// 	stepIndex: tour.stepIndex
			// })
		// }

	},[loading])

	useEffect(() => {
		if(data?.auth === AUTH_NOT_AUTHORIZED){
			fetchLogout();
		}
	},[data?.auth]);

	if(loading){
		return <div className={css.event}><Spinner/></div>
	}

	if(!data){
		return <NotFound/>
	}

    return (
	    <>
		    <div className={lCss.content + ' ' + lCss.visible}>
		        <div className={css.event}>
			        <span className={css.back} onClick={()=> history.goBack()}>
						<Icons name="back"/>
			        </span>
			        <div className={css.header}>
		                <span className={css.date}>
			                {getTime(announce.occurs_from, announce.occurs_till)
				                ? <span className={css.time}>{getTime(announce.occurs_from, announce.occurs_till)}</span>
				                : null
			                }
			                {formatDate(announce.occurs_from, announce.occurs_till)}
		                </span>
				        {list_ids.includes(CATEGORY_ONLINE) && <span className={css.category + ' ' + css.online}>онлайн</span>}
				        {list_ids.includes(CATEGORY_RIAN) && <span className={css.category + ' ' + css.mmpc}>мероприятие ММПЦ</span>}
			        </div>

			        <div className={css.title}>
				        {announce.article_title}
			        </div>

		            <div className={css.body} dangerouslySetInnerHTML={{ __html: announce.article_body }}/>

			        {!user.isExternalUser
			        	? <div className={css.lead} dangerouslySetInnerHTML={{ __html: announce.article_lead}}></div>
				        : null
			        }

		            <div className={css.list}>
		                {announceCategories.filter(el => categories.map(e => e.list_id).includes(el.list_id)).map((item,i) =>
			                <div key={item.list_id} onClick={()=> setCategory(item)} className={css.category}>{item.list_title}</div>
		                )}
		            </div>
			        <div className={css.socialSidebar}>
				        <div className={css.social} data-target="share">
					        <span className={css.socialItem + ' '+ css.mail} onClick={openSendAnnounces}>
						        <Icons name="mail"/>
					        </span>
					        <span className={css.socialItem} rel="noreferrer" onClick={copyToClipboard}>
						        <Icons name="copy"/>
						        <span className={css.socialCopy + ' ' + (copySuccess ? css.active :'')}>Скопировано</span>
					        </span>
				        </div>
					</div>
		        </div>
		    </div>

	    </>
    );
}